/*eslint-disable*/
import api from '../'

class textsGameItems {
    // GET: items
    static getItemsByRequest (params) {
        return api.axios.post('/texts', params).then(response => response.data.texts);
    }

    //POST: text
    static saveTextToDB (params) {
        return api.axios.post('/saveText', params).then(response => response.data);
    }

    static updateTextData (params) {
        return api.axios.post('/updateText', params).then(response => response.data);
    }

    static getAvailableTextsAccesses() {
        return api.axios.get('/getAvailableTextAccesses').then(response => response.data);
    }

    static deleteText (id) {
        return api.axios.delete('/deleteText/' + id).then(response => response.data)
    }
}

export default textsGameItems;
